import React from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {Icon, Tooltip} from "@mui/material";
import AppBar from "@mui/material/AppBar/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {Input} from "@mui/material";
import {closeDialog, openDialog} from "../store/global/dialogSlice";
import store from "../store";

export default class Alert {

    static error(message, callback) {
        store.dispatch(openDialog({
            children: (
                <React.Fragment>
                    <DialogContent dividers>
                        <DialogContentText>
                            {message || 'Por favor intente nuevamente o contacte a soporte.'}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary"
                                onClick={() => {
                                    store.dispatch(closeDialog());
                                    if (typeof callback === 'function') {
                                        callback();
                                    }
                                }}>
                            Aceptar
                        </Button>
                    </DialogActions>
                </React.Fragment>
            ),
        }))
    }

    static prompt(title, callback, subtitle, confirmButton = 'Aceptar', cancelButton = 'Cancelar') {
        let text = '';
        store.dispatch(openDialog({
            children: (
                <React.Fragment>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogContent dividers>

                        <div style={{minWidth: 460}}>
                            <Input
                                label=""
                                autoFocus
                                onChange={e => {
                                    text = e.target.value;
                                }}
                                placeholder={subtitle}/>
                        </div>

                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="default"
                            onClick={() => {
                                store.dispatch(closeDialog());
                            }}>
                            {cancelButton}
                        </Button>
                        <Button
                            color="secondary"
                            onClick={() => {
                                store.dispatch(closeDialog());
                                callback(text);
                            }}>
                            {confirmButton}
                        </Button>
                    </DialogActions>
                </React.Fragment>
            ),
            onExit  : () => {
            },
        }))
    }

    static show(title, message, callback) {
        if (!message) {
            message = title;
            title = null;
        }
        store.dispatch(openDialog({
            children: (
                <React.Fragment>
                    {title && <DialogTitle>{title}</DialogTitle>}
                    <DialogContent dividers>
                        <DialogContentText>{message}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="primary"
                            onClick={() => {
                                store.dispatch(closeDialog());
                                if (typeof callback === 'function') {
                                    callback();
                                }
                            }}>
                            Aceptar
                        </Button>
                    </DialogActions>
                </React.Fragment>
            ),
            onExit  : () => {
            },
        }))
    }

    /**
     * Dialogo de confirmacion, los parametros pueden ser flexibles, de derecha a izquierda, excepto el callback
     * El callback solo será llamado el botón positivo (confirmar) es accionado
     *
     * EJEMPLOS DE USO:
     * Alert.confirm('Mensaje', 'Si, eliminar', () => {});
     * Alert.confirm('Mensaje', () => {});
     * Alert.confirm(() => {});
     */
    static confirm(message, confirmButton, callback) {

        let opts = {
            title        : '',
            message      : '',
            info         : '',
            confirmButton: 'Confirmar',
            cancelButton : 'Cancelar',
            callback     : () => {
            },
            /**
             * true: solo se llamara el callback cuando se presione el boton Confirmar
             * false: se llamara callback(true|false), enviara true si fue por confirmButton
             */
            onlyConfirm: true,
        };

        if (typeof message === 'object') {
            opts = {...opts, ...message};

        } else if (typeof message === 'function') {
            opts.callback = message;

        } else if (typeof confirmButton === 'function') {
            opts.message = message;
            opts.callback = confirmButton;

        } else {
            opts.message = message;
            opts.confirmButton = confirmButton;
            opts.callback = callback;
        }

        if (!opts.title && !opts.message) {
            opts.title = '¿Estás seguro?';
            opts.message = 'Esta acción no tiene marcha atrás.';
        }

        store.dispatch(openDialog({
            children       : (
                <React.Fragment>
                    {opts.title && (
                        <DialogTitle>{opts.title}</DialogTitle>
                    )}
                    <DialogContent dividers>
                        <DialogContentText color="textPrimary">{opts.message}</DialogContentText>
                        {opts.info && (
                            <DialogContentText color="textSecondary" variant="caption" className="mt-16">
                                <Icon fontSize="inherit" style={{verticalAlign: 'middle',}}
                                      color="disabled">info</Icon> {opts.info}
                            </DialogContentText>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="inherit"
                            onClick={() => {
                                store.dispatch(closeDialog());
                                if (!opts.onlyConfirm) {
                                    opts.callback(false);
                                }
                            }}>
                            {opts.cancelButton}
                        </Button>
                        <Button
                            color="secondary"
                            autoFocus
                            onClick={() => {
                                store.dispatch(closeDialog());
                                opts.callback(true);
                            }}>
                            {opts.confirmButton}
                        </Button>
                    </DialogActions>
                </React.Fragment>
            ),
            onBackdropClick: () => {
                if (!opts.onlyConfirm) {
                    opts.callback(false);
                }
            },
        }))

    }

    static web(url, title = null) {
        store.dispatch(openDialog({
            fullScreen: true,
            children  : <>
                <AppBar position="static">
                    <Toolbar>
                        <div style={{flexGrow: 1}}>
                            {title && (
                                <Typography variant="h6" style={{lineHeight: '18px'}}>{title}</Typography>
                            )}
                        </div>
                        <Tooltip title="Cerrar">
                            <IconButton
                                onClick={() => store.dispatch(closeDialog())}
                                color="inherit">
                                <Icon>close</Icon>
                            </IconButton>
                        </Tooltip>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers style={{padding: 0}}>
                    <iframe style={{width: '100%', height: '100%'}} src={url}/>
                </DialogContent>
            </>,
            onExit    : () => {
            },
        }))
    }
}
